import * as L from 'leaflet'

import 'leaflet.markercluster/dist/leaflet.markercluster.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import '~/components/ui/iiif/leaflet-iiif-rotate.js'
import '~/components/ui/iiif/leaflet-roate-image.js'
import '~/components/ui/iiif/Leaflet.Editable.js'
import '~/components/ui/iiif/leaflet.path.drag.js'

export default defineNuxtPlugin(() => {

  // --- public ---
  const createLeafletMap = (element: HTMLElement, param: any): L.Map => {
    return L.map(element, param)
  }

  const createLeafletLayerGroup = (): L.LayerGroup => {
    return new L.LayerGroup()
  }

  const createLeafletLatLngBounds = (southWest: any, northEast: any): L.LatLngBounds => {
    return new L.LatLngBounds(southWest, northEast)
  }

  const createLeafletUrlImage = (src: string, bouds: L.LatLngBounds, param: any, layer: L.LayerGroup): L.ImageOverlay => {
    return L.rotateImageLayer(src, bouds, param).addTo(layer)
  }

  const getLeafletCrsSimple = (): any => {
    return L.CRS.Simple
  }

  const createLeafletIIIFLayer = (url: string, param: any): any => {
    return L.GridLayer.iiifRotate(url, param)
  }

  const createLeafletRectangle = (map: L.Map, url: string,
                                  x: number, y: number,
                                  w: number, h: number): L.Rectangle => {
    return new L.Rectangle(mapBoundPoint2LatLng(map, url, x, y, w, h))
  }

  const setLeafletTileLayer = (map: L.Map, url: string, param: any): void => {
    L.tileLayer(url, param).addTo(map)
  }

  const createLeafletCircle = (map: L.Map, points: number[], param: any): L.Circle => {
    return L.circle(points, param).addTo(map)
  }

  const createLeafletMarkerClusterGroup = (param: any): L.LayerGroup => {
    return L.markerClusterGroup(param)
  }

  const createLeafletIcon = (param: any): any => {
    return L.icon(param)
  }

  const createLeafletMarker = (points: number[], param: any): any => {
    return L.marker(points, { alt: '', ...param })
  }

  // --- private ---
  const mapBoundPoint2LatLng = (map: L.Map, url: string,
                                x: number, y: number,
                                w: number, h: number): L.LatLngBounds => {
    return new L.LatLngBounds(
      mapPoint2LatLng(map, url, x, y),
      mapPoint2LatLng(map, url, x + w, y + h),
    )
  }

  const mapPoint2LatLng = (map: L.Map, url: string,
                           x: number, y: number): L.LatLng => {
    return map.unproject(
      [x, y],
      url ? map.getMaxZoom() : map.getMaxZoom() - 1,
    )
  }


  return {
    provide: {
      createLeafletMap,
      createLeafletLayerGroup,
      createLeafletLatLngBounds,
      createLeafletUrlImage,
      getLeafletCrsSimple,
      createLeafletIIIFLayer,
      createLeafletRectangle,
      setLeafletTileLayer,
      createLeafletCircle,
      createLeafletMarkerClusterGroup,
      createLeafletIcon,
      createLeafletMarker,
    },
  }

})
